import { render, staticRenderFns } from "./App2019.vue?vue&type=template&id=c5e1b048&scoped=true&"
import script from "./App2019.vue?vue&type=script&lang=js&"
export * from "./App2019.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e1b048",
  null
  
)

export default component.exports